export default __webpack_public_path__ + "static/zahid-d6de1064048be608d0f77e2099e67181.png";